import { render, staticRenderFns } from "./viewingDisciplineSections.vue?vue&type=template&id=57913eea"
import script from "./viewingDisciplineSections.vue?vue&type=script&lang=js"
export * from "./viewingDisciplineSections.vue?vue&type=script&lang=js"
import style0 from "./viewingDisciplineSections.vue?vue&type=style&index=0&id=57913eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports